import { createSlice } from '@reduxjs/toolkit';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { INIT_LOCAL__grid2d_delete } from './grid2d/LOCAL__grid2d_delete';
import { init_local_grid2d_upsert } from './grid2d/LOCAL__grid2d_upsert';
import { init_local_grid2d_update_partial } from './grid2d/local_grid2d_update_partial';
import { init_remote_grid2d_download_images } from './grid2d/remote_grid2d_download_images';
import { INIT_LOCAL__grid2d_cells_delete } from './grid2d_cell/LOCAL__grid2d_cells_delete';
import { INIT_LOCAL__grid2d_cells_upsert } from './grid2d_cell/LOCAL__grid2d_cells_upsert';
import { INIT_LOCAL__grid2d_chunk_update_without_cells } from './grid2d_chunk/LOCAL__grid2d_chunk_update_without_cells';
import { init_local_grid2d_chunk_upsert } from './grid2d_chunk/local_grid2d_chunk_upsert';
import { INIT_REMOTE__grid2d_chunk_load_cells } from './grid2d_chunk/REMOTE__grid2d_chunk_load_cells';
import { INIT_REMOTE__grid2d_get_by_entity_type_and_id } from './grid2d_for_entity/REMOTE__grid2d_get_by_entity_type_and_id';
import { INIT_REMOTE__grid2d_get_generation } from './grid2d_for_entity/REMOTE__grid2d_get_generation';
import { init_remote_grid2d_get_search } from './grid2d_for_entity/remote_grid2d_get_search';
import { init_remote_grid2d_get_user_task } from './grid2d_for_entity/remote_grid2d_get_user_task';
import { STATE__grid2d } from './STATE__grid2d';

export const initialStateGrid2d: STATE__grid2d = {
  grids2d_map: new Map(),

  grid2d_loading_in_progress: new Set(),

  grid2d_chunk_cells_loading_in_progress: new Set(),

  grid2d_images_download_in_progress: new Set(),
};

export const slice_grid2d = createSlice({
  name: ENUM__redux_slice.GRID2D,
  initialState: initialStateGrid2d,
  reducers: {
    grid2d_upsert: init_local_grid2d_upsert,
    grid2d_update_partial: init_local_grid2d_update_partial,
    grid2d_delete: INIT_LOCAL__grid2d_delete,

    grid2d_cells_upsert: INIT_LOCAL__grid2d_cells_upsert,
    grid2d_cells_delete: INIT_LOCAL__grid2d_cells_delete,

    grid2d_chunk_upsert: init_local_grid2d_chunk_upsert,
    grid2d_chunk_update_without_cells: INIT_LOCAL__grid2d_chunk_update_without_cells,
  },

  extraReducers: builder => {
    init_remote_grid2d_get_user_task(builder);
    INIT_REMOTE__grid2d_get_generation(builder);
    init_remote_grid2d_get_search(builder);
    INIT_REMOTE__grid2d_get_by_entity_type_and_id(builder);
    init_remote_grid2d_download_images(builder);

    INIT_REMOTE__grid2d_chunk_load_cells(builder);

    builder.addCase(LOCAL__global_reset, state => {
      return initialStateGrid2d;
    });
  },
});
